import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  OSType,
  TimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { OsVersionConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "os-versions-details",
  templateUrl: "./os-versions-details.component.html",
  standalone: false,
})
export class OsVersionsDetailsComponent
  extends BaseDetailsLogic<OsVersionConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, OsVersionConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedOSType(): string | OSType {
    return this.config?.osType as OSType;
  }

  set selectedOSType(value: string | OSType) {
    this.config.osType = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod: 'Pick a time period to see which operating system versions were used during that time. For example, you can look at OS versions used in the last week, month, or year. This helps you understand which OS versions are most common among your users.',
      osType: 'Choose which operating system type you want to see version data for. For example, you can select Windows, Android, or iOS to focus on specific OS version information.'
    };
  }
}
